import StarryGlobe from './components/StarryGlobe';
import './App.css';
import './globe.css';
import AnalyticsDashboard from './components/Dashboard';

function App() {
  return (
    <div className="App">
      <StarryGlobe />
      <AnalyticsDashboard />
    </div>
  );
}

export default App;